import { SaveOutlined } from '@ant-design/icons';
import { AutoComplete, Button } from 'antd';
import { EditIcon } from 'assets/images';
import PropType from 'prop-types';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateMachineField } from '../../state/operation';

export const UpdateMachineField = (props) => {
  const dispatch = useDispatch();
  const ENTER_KEYCODE = 13;
  const { id, value, fieldName, options } = props;
  const [open, setOpen] = useState(false);
  const [fieldValue, setFieldValue] = useState('');
  const handleOpen = () => {
    setOpen((prevState) => !prevState);
    if (open && value !== fieldValue) {
      dispatch(updateMachineField(id, { [fieldName]: fieldValue }));
    }
  };
  const handleInput = (inputValue) => {
    setFieldValue(inputValue);
  };
  const handleUpdate = (e) => {
    setFieldValue(e.target.value);
    if (e.keyCode === ENTER_KEYCODE && fieldValue) {
      dispatch(updateMachineField(id, { [fieldName]: fieldValue }));
      setOpen((prevState) => !prevState);
    }
  };

  return (
    <div className="update-machine-field">
      <Button
        icon={open ? <SaveOutlined /> : <EditIcon />}
        onClick={handleOpen}
        className="alias-editable-button"
      />
      <AutoComplete
        className={`w-100 alias-editable ${open && 'alias-editable-edit'}`}
        options={options}
        filterOption={(inputValue, option) =>
          option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
        }
        searchValue={fieldValue || value}
        disabled={!open}
        onSelect={handleInput}
        onKeyUp={handleUpdate}
      />
    </div>
  );
};

UpdateMachineField.propTypes = {
  id: PropType.string.isRequired,
  value: PropType.string,
  fieldName: PropType.string.isRequired,
  options: PropType.arrayOf(PropType.shape({}))
};

UpdateMachineField.defaultProps = {
  value: '',
  options: []
};

export default UpdateMachineField;
